const COLOR_OPTIONS = [
  "#4B8702",
  "#527EE5",
  "#FCA311",
  "#36BC9B",
  "#7CCCE5",
  "#c25bd4",
  "#B7D968",
  "#B576AD",
  "#555E7B",
  "#D2C2FC",
  "#E8D399",
  "#F7CA6F",
  "#FCB5FC",
  "#1AB712",
  "#EA85B1",
];

const REPORT_RESULT = "reportResultLst";
const REPORT_RESULT_EXTRA = "reportResultExtraLst";
const MY_TYPE_MY_COUNTY = "myTypeMyCounty";
const MY_TYPE_MY_STATE = "myTypeMyState";

const buildResultList = (data) => {
  const allResultList = [];

  const myCounty = data.myCounty;
  const myState = data.myState;

  if (REPORT_RESULT in myCounty && REPORT_RESULT in myState) {
    const myCountyResultList = myCounty.reportResultLst;
    const myStateResultList = myState.reportResultLst;

    allResultList.push(...myCountyResultList);
    allResultList.push(...myStateResultList);
  }

  if (MY_TYPE_MY_COUNTY in data && MY_TYPE_MY_STATE in data) {
    const myTypeMyCounty = data.myTypeMyCounty;
    const myTypeMyState = data.myTypeMyState;

    if (
      REPORT_RESULT_EXTRA in myTypeMyCounty &&
      REPORT_RESULT_EXTRA in myTypeMyState
    ) {
      const myTypeMyCountyResultList = myTypeMyCounty.reportResultExtraLst;
      const myTypeMyStateResultList = myTypeMyState.reportResultExtraLst;

      allResultList.push(...myTypeMyCountyResultList);
      allResultList.push(...myTypeMyStateResultList);
    } /* if: list of results was returned */
  }

  return allResultList;
};

const buildCategories = (data) => {
  const categories = new Set();
  data.forEach((obj) => {
    categories.add(
      `${obj.region}${obj.entityType ? `-${obj.entityType}` : ""}`
    );
  });
  return categories;
};

export const newPieHash = (data) => {
  const allData = buildResultList(data);
  const allCategories = [...buildCategories(allData)];

  const labelsTmp = [],
    labels = [];

  for (let i = 0; i < allData.length; i++) {
    if (labelsTmp[allData[i].label]) {
      continue;
    }
    labelsTmp[allData[i].label] = true;
    labels.push(allData[i].label);
  }

  const newData = allData.reduce((acc, obj) => {
    const category = `${obj.region}${obj.entityType ? `-${obj.entityType}` : ""
      }`;
    const categoryIndex = allCategories.indexOf(category);
    //TODO (research support for tooltip showing entity count) const countSuffix = obj.count != 1 ? 'entities' : `entity`;
    if (!acc[obj.label]) {
      acc[obj.label] = {
        values: [null, null, null, null],
        text: obj.label,
        category,
      };
    }
    acc[obj.label].values.splice(categoryIndex, 1, +obj?.percentage.toFixed(2) || null);

    return acc;
  }, {});

  const keys = Object.keys(newData);
  const pieData = keys.map((key, i) => {
    return {
      ...newData[key],
      backgroundColor: COLOR_OPTIONS[i],
    };
  });

  return {
    pieData,
    categories: allCategories,
    legendItemCount: labels.length,
  };
};

export const newBarHash = (data) => {
  const labelsTmp = [],
    labels = [];

  for (let i = 0; i < data.length; i++) {
    if (labelsTmp[data[i].label]) {
      continue;
    }
    labelsTmp[data[i].label] = true;
    labels.push(data[i].label);
  }

  const chartData = data.map((obj, i) => {
    return {
      values: [+obj?.percentage.toFixed(2)],
      text: obj.label,
      backgroundColor: COLOR_OPTIONS[i % COLOR_OPTIONS.length],
    };
  });

  return {
    chartData,
    categories: [
      data[0].region
    ],
    legendItemCount: labels.length,
  };
};

export const newLargeBarHash = (data) => {
  const allData = buildResultList(data);
  const allCategories = [...buildCategories(allData)];

  const labelsTmp = [],
    labels = [];

  for (let i = 0; i < allData.length; i++) {
    if (labelsTmp[allData[i].label]) {
      continue;
    }
    labelsTmp[allData[i].label] = true;
    labels.push(allData[i].label);
  }

  const newData = allData.reduce((acc, obj) => {
    const category = `${obj.region}${obj.entityType ? `-${obj.entityType}` : ""
      }`;
    const categoryIndex = allCategories.indexOf(category);
    if (!acc[obj.label]) {
      acc[obj.label] = {
        values: [null, null, null, null],
        text: obj.label,
        category,
      };
    }

    acc[obj.label].values.splice(categoryIndex, 1, +obj?.percentage.toFixed(2) || null);

    return acc;
  }, {});

  const keys = Object.keys(newData);
  const barData = keys.map((key, i) => {
    return {
      ...newData[key],
      backgroundColor: COLOR_OPTIONS[i],
    };
  });

  return {
    barData,
    categories: allCategories,
    legendItemCount: labels.length,
  };
};

export const newPremiumContribution = (data = {}) => {
  const average = data.average || data.entityType;
  const myGroup = data.myGroup;

  const barData = [
    {
      text: "My Group",
      values: [
        myGroup.monthlyPremium,
        myGroup.employerContribution,
        myGroup.employeeContribution,
      ],
    },
    {
      text: "Averages",
      values: [
        average.monthlyPremium,
        average.employerContribution,
        average.employeeContribution,
      ],
    },
  ];

  return {
    barData,
    categories: [
      "Monthly Premium",
      "Employer Contribution",
      "Employee Contribution",
    ],
  };
};

export const newTierGroupingDataHash = (data = {}, findKey = "") => {
  const oldKeys = Object.keys(data).filter(function (field) {
    return field.endsWith(findKey);
  });

  const dataObjects = oldKeys.map((key) => data[key]);
  const allData = dataObjects.map((d) =>
    d.reportResultLst ? d.reportResultLst : d.reportResultExtraLst
  );

  const labelsTmp = [],
    labels = [];

  const newData = allData.reduce((acc, obj) => {
    for (let i = 0; i < obj.length; i++) {
      const el = obj[i];
      if (!acc[el.label]) {
        acc[el.label] = {
          values: [null, null, null, null],
          text: el.label,
        };
      }
    }

    return acc;
  }, {});

  for (let i = 0; i < allData.length; i++) {
    const el = allData[i];
    for (let j = 0; j < el.length; j++) {
      const d = el[j];
      newData[d.label].values[i] = d.percentage;

      if (labelsTmp[d.label]) {
        continue;
      }
      labelsTmp[d.label] = true;
      labels.push(d.label);
    }
  }

  const keys = Object.keys(newData);
  const pieData = keys.map((key, i) => {
    return {
      ...newData[key],
      backgroundColor: COLOR_OPTIONS[i],
    };
  });
  return {
    pieData,
    legendItemCount: labels.length,
  };
};
